module.exports = __webpack_public_path__ + "img/xuzhou.23db1023.png";